/* eslint-disable no-multi-spaces */
import * as yup from 'yup';


const TEXT_WHITESPACE = [
    '\\p{Zs}'
];

const TEXT_STRICT_VISIBLE = [
    '\\p{Script=Latin}',
    '\\d',
    '.',
    ',',
    ':',
    ';',
    '/',
    '\'',
    '\\-'
];

const TEXT_STRICT_VISIBLE_WHITESPACE = TEXT_STRICT_VISIBLE.concat(TEXT_WHITESPACE);

const TEXT_STRICT_REGEXP_ALLOWED = new RegExp(
    `^[${TEXT_STRICT_VISIBLE.join('')}]+[${TEXT_STRICT_VISIBLE_WHITESPACE.join('')}]*$`,
    'gu'
);
const TEXT_STRICT_REGEXP_DENIED = new RegExp(`[^${TEXT_STRICT_VISIBLE.join('')}]+`, 'gu');


const TEXT_FREE_ALLOWED = TEXT_STRICT_VISIBLE_WHITESPACE.concat(
    [
        '\\n',
        '\\r',
        '+',
        '*',
        '=',
        '#',
        '!',
        '?',
        '_',
        '´',
        '`',
        '’',
        '‘'
    ]
);

const TEXT_FREE_REGEXP_ALLOWED = new RegExp(`^[${TEXT_FREE_ALLOWED.join('')}]+$`, 'gu');
const TEXT_FREE_REGEXP_DENIED = new RegExp(`[^${TEXT_FREE_ALLOWED.join('')}]+`, 'gu');


const textValidation = (regexpAllowed, regexpDenied, {message} = {}) => {

    return function (value) {

        const {path, createError} = this;

        const coercedValue = value || '';
        if (!coercedValue) {

            return true;
        }

        const isCorrect = coercedValue.match(regexpAllowed);
        if (isCorrect) {

            return true;
        }

        const deniedCharacters = coercedValue.match(regexpDenied) || [];

        return createError({
            message: message || 'i18n:form.error.text-validation',
            params: {
                chars: deniedCharacters.join(', ')
            },
            path
        });
    };
};


yup.addMethod(yup.string, 'strictText', function (options) {

    const testFunction = textValidation(TEXT_STRICT_REGEXP_ALLOWED, TEXT_STRICT_REGEXP_DENIED, options);

    return this.test('text-validation', 'not-allowed-character', testFunction);
});


yup.addMethod(yup.string, 'freeText', function () {

    const testFunction = textValidation(TEXT_FREE_REGEXP_ALLOWED, TEXT_FREE_REGEXP_DENIED);

    return this.test('text-validation', 'not-allowed-character', testFunction);
});
